import { render, staticRenderFns } from "./preference-widget-other-config-card.vue?vue&type=template&id=4075e2a3"
import script from "./preference-widget-other-config-card.vue?vue&type=script&lang=js"
export * from "./preference-widget-other-config-card.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports